document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.querySelector('.form-field--account-password .password-toggle');
    const input  = document.querySelector('#customer_password');
    if (!toggle || !input) return;
  
    toggle.addEventListener('click', function() {
      const willShow = input.type === 'password';
      input.type = willShow ? 'text' : 'password';
      toggle.classList.toggle('active', willShow);
      toggle.setAttribute(
        'aria-label',
        willShow
          ? '{{ "customers.login.hide_password" | t }}'
          : '{{ "customers.login.show_password" | t }}'
      );
    });
  });
  